import styled from "styled-components";
import { Link as LinkScroll } from "react-scroll";
import { Link as LinkRouter } from "react-router-dom";

export const Nav = styled.nav`
  background: ${({ scrollNav }) => (scrollNav ? "#e0d8e8" : "#e0d8e8")};
  height: 80px;
  /* margin-top: -80px; */
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  z-index: 10;
  font-size: 1rem;
  position: sticky;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.19);
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
  }
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  height: 80px;
`;
export const NavLogo = styled(LinkRouter)`
  color: #333;
  justify-self: flex-start;
  cursor: pointer;
  font-size: 1.5rem;
  text-decoration: none;
  margin-left: 24px;
  font-weight: bold;
  display: flex;
  align-items: center;

  @media screen and (max-width: 768px) {
    margin-left: 16px;
  }
`;
export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: block;
    font-size: 1.8rem;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    cursor: pointer;
    color: #333;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  margin-right: 22px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;
export const NavItem = styled.li`
  height: 80px;
`;
export const NavLinks = styled(LinkScroll)`
  display: flex;
  align-items: center;
  padding: 0 1rem;
  color: #444;
  cursor: pointer;
  text-decoration: none;
  height: 100%;

  &.active {
    border-bottom: 4px solid #845ec2;
  }
`;
export const BtnWrapper = styled.nav`
  display: flex;
  align-items: center;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;
export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;
export const IconLink = styled.a`
  font-size: 1.5rem;
  cursor: pointer;
  text-decoration: none;
  color: #333;
  margin-right: 20px;

  &.active {
    color: none;
  }
`;
